import React from 'react';
const About = (props) => {
    return (
        <div style={{height:'50px'}}>
<nav id="navbar-example2" className="navbar navbar-light bg- #e3f2fd  px-3 my-5">
  <h className="navbar-brand" href="/"> <h3>About</h3></h>
  {/* <ul className="nav nav-pills">
    <li className="nav-item">
      <a className="nav-link" href="#scrollspyHeading1">First</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" href="#scrollspyHeading2">Second</a>
    </li>
    <li className="nav-item dropdown">
      <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="/" role="button" aria-expanded="false">Dropdown</a>
      <ul className="dropdown-menu">
        <li><a className="dropdown-item" href="#scrollspyHeading3">Third</a></li>
        <li><a className="dropdown-item" href="#scrollspyHeading4">Fourth</a></li>
        <li><hr className="dropdown-divider"/></li>
        <li><a className="dropdown-item" href="#scrollspyHeading5">Fifth</a></li>
      </ul>
    </li>
  </ul> */}
</nav>
<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="0" className="scrollspy-example" tabindex="0">
  <p id="scrollspyHeading1">Misc.</p>
  <p>Shopping Cart App using React and Firebase</p>
  {/* <p id="scrollspyHeading2">Second heading</p>
  <p>...</p>
  <p id="scrollspyHeading3">Third heading</p>
  <p>...</p>
  <p id="scrollspyHeading4">Fourth heading</p>
  <p>...</p>
  <p id="scrollspyHeading5">Fifth heading</p>
  <p>...</p> */}
</div>
</div>
    );
}
export default About;